import { z } from "zod";

const translationPath = "page.4uDlist.listCategory.errors.";

export const listCategorySchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  name: z
    .string()
    .trim()
    .min(1, translationPath + "name"),
  description: z.string().nullish(),
});

export type TListCategoryForm = z.infer<typeof listCategorySchema>;
